import { componentSettings } from "./componentSettings.js"
import { pageKeys, pagesNames } from "./pageKeys.js"
import { globalItems, globalItemsMeta, headerComponents, socialNetworks, supportNetworks } from "./globalMeta.js"
import { availableComponents, componentListHeaders } from "./availableComponents.js"
import { defaultGlobalSettings } from "./defaultGlobalSettings.js"
import gamesList from "./gamesList.json"
import { tooltipImages } from "./tooltipImages.js"

const componentTooltipImages = {}
for (const section of Object.values(availableComponents)) {
  if (!Array.isArray(section)) continue
  for (const comp of section) {
    if (comp.type && comp.icon && tooltipImages[comp.icon]) {
      componentTooltipImages[comp.type] = tooltipImages[comp.icon]
    }
  }
}

export const mellConfig = {
  componentSettings,
  pageKeys,
  pagesNames,
  globalItems,
  globalItemsMeta,
  headerComponents,
  socialNetworks,
  supportNetworks,
  availableComponents,
  componentListHeaders,
  defaultGlobalSettings,
  gamesList,
  componentTooltipImages,
  bannerImageConstraints: {
    variants: [
      { width: 1668, height: 1056 },
      { width: 1114, height: 542 },
    ],
  },
  middleBannerConstraints: {
    desktop: { width: 1500, height: 350 },
    mobile: { width: 1668, height: 1056 },
  },
  promoPageKey: "promotions",
}

export default mellConfig
